'use client';
/* Built In Imports */
import dynamic from 'next/dynamic';
import { useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import ScrollToTop from '@app-ps/Components/Utility/ScrollToTop';

/* Services */
// const Header = dynamic(() => import(`@app-ps/Components/Header/index`))
const WithPreview = dynamic(() => import('@app-ps/Components/PreviewMode'));

/**
 * Renders the Layout component.
 *
 * @param children.children
 * @param {object} children - Child Elements.
 * @returns {ReactElement} Layout component
 */
export default function Layout({ children }) {
  // const {
  //   headerMenuData,
  //   pageData,
  //   footerData,
  //   footerDetailData,
  //   region,
  //   lang,
  //   isPreview,
  //   headerVisible = true,
  //   page,
  //   secondMenuVisible = true,
  //   hideTopMenu = false,
  //   isHome,
  // } = children.props;
  let pageConfig = '';
  // console.log('children.props', children.props);

  const [currentUserRegion, setCurrentUserRegion] = useState('in');
  const [showHeader, setShowHeader] = useState(true);

  // const authContext = useContext(AuthContext);
  const language = 'en';

  // useEffect(() => {
  //   setShowHeader(headerVisible);
  // }, [children.props]);

  return (
    <Box
      className={`lang-${language || 'en'}`}
      // pb={{ md: '0', base: isSticky ? '80px' : '' }}
    >
      {/* main content to render */}
      {children}
      {/* Footer section */}
      {/* {(footerData || footerDetailData) && (
        <Box pos="relative" w="100%" zIndex="100">
          <Footer
            region={region}
            language={language}
            footerData={footerData}
            pageConfig={pageConfig}
            page={page}
          />
        </Box>
      )} */}
      {/* {isPreview && <WithPreview isPreview={isPreview} />} */}
      <ScrollToTop />
    </Box>
  );
}
